// extracted by mini-css-extract-plugin
export default {"small-badge":"kxgzsm8F","smallBadge":"kxgzsm8F","selected":"D5qPhcPW"};